module.exports = __webpack_public_path__ + "img/Icon_boleto_exclude.8f5cd136.svg";